export function convertToHHMM(dateString) {
    const date = new Date(dateString);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}h${minutes}`;
}

export function convertToDateWithHHMM(dateString) {
    const daysOfWeek = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
    const months = [
      'janvier', 'février', 'mars', 'avril', 'mai', 'juin', 
      'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
    ];
  
    const date = new Date(dateString);
    const dateNow = new Date();
  
    const dayOfWeek = daysOfWeek[date.getDay()];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    const sameDay = (date.getDate() === dateNow.getDate()) && (date.getMonth() === dateNow.getMonth()) && (date.getFullYear() === dateNow.getFullYear())
  
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
  
    return sameDay ? convertToHHMM(dateString) : `${dayOfWeek} ${day} ${month} ${year} - ${hours}h${minutes}`;
  }